// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.checkStatusCd-blinking {\n  -webkit-animation:checkStatusCd-blink 2s ease-in-out infinite alternate;\n  animation:checkStatusCd-blink 2s ease-in-out infinite alternate;\n}\n@-webkit-keyframes checkStatusCd-blink {\n0% { opacity:0\n}\n100% { opacity:1\n}\n}\n@keyframes checkStatusCd-blink {\n0% { opacity:0\n}\n100% { opacity:1\n}\n}\n", ""]);
// Exports
module.exports = exports;
